// import React from 'react';

const AppLayoutWrapper = ({ children }) => {
  return children;
};

export default AppLayoutWrapper;
